<template>
  <ul class="clearfix">
    <li class="store-item"
      v-for="store in data"
    >
      <div class="img">
        <router-link :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}"
          :title="store.storeName"
        >
          <img class="scrollLoading" :src="store.storeImgsUrl" :alt="store.storeName" width="306" height="229"/>
        </router-link>
      </div>
      <p>
        <router-link :to="{path:'/shop',query:{tab:1,store_id:store.storeId}}"
          :title="store.storeName"
        >
        {{store.storeName}}
        </router-link>
      </p>
      <p class="name">{{store.storeName}}</p>
      <p class="phonenum">{{store.tel}}</p>
      <p class="adress">{{store.attr}}</p>
    </li>
  </ul>
</template>
<script>
export default {
  props:["data"]
}
</script>


// WEBPACK FOOTER //
// list.vue?11785ee6